import { ClientSelection } from './clientSelection.interface';

export enum SelectionType {
  AutoDetected,
  ClientAction,
}

export type SelectionWithPriority = ClientSelection & { priority: Record<keyof ClientSelection, SelectionType> };
export type ClientSelectionStorage = { setItem: (v: SelectionWithPriority) => void; getItem: () => SelectionWithPriority | null };

export class ClientSelectionService {
  #storage: ClientSelectionStorage;

  constructor(storage: ClientSelectionStorage) {
    this.#storage = storage;
  }

  register(values: Partial<ClientSelection>, type: SelectionType = SelectionType.AutoDetected) {
    const existingSelections = this.#storage.getItem() || ({ priority: {} } as SelectionWithPriority);

    const nextValues = Object.entries(values).reduce((acc, [key, value]) => {
      const existingPriority = existingSelections.priority[key] || SelectionType.AutoDetected;
      if (existingPriority <= type) {
        // @ts-ignore
        acc[key] = value;
        acc.priority[key] = type;
      }
      return acc;
    }, existingSelections);
    this.#storage.setItem({ ...nextValues });
  }

  getSelections(): ClientSelection {
    const { priority: _, ...item } = this.#storage.getItem() || {};
    return item;
  }
}
